import './BrandEquityHeader.scss';
import { ReactElement } from 'react';
import { Img } from '@Components/Img';

// The Brand Equity page hero: pitch copy + funnel infographic. Rendered atop both the Brand
// Impact and Business Impact tabs (previously a byte-identical copy in each tab's shell).
export const BrandEquityHeader = (): ReactElement => (
  <div className='brand-equity-header'>
    <div className='brand-equity-text-header'>
      <div className='brand-equity-text-header-title'>
        A strong brand drives business outcomes and creates a tailwind for performance marketing
      </div>
      <div className='brand-equity-text-header-paragraph'>
        Performance marketing generates results over days to weeks. Brand marketing operates over
        months to years, making unified assessment of the funnel challenging.
      </div>
      <div className='brand-equity-text-header-paragraph'>
        Bliss Point Brand Health quantifies brand equity&apos;s impact on the business for a
        holistic understanding of ROAS.
      </div>
    </div>
    <div className='brand-equity-header-image-container'>
      <Img
        src='https://cdn.blisspointmedia.com/assets/img/BusinessImpactDemo/BrandEquity_Infographic.png'
        alt='brand health header'
      />
    </div>
  </div>
);
